import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import Immutable from 'immutable';
import * as actionTypes from './action-types';
import ResultRecord from './result-record';

var searchReducer = function searchReducer(state, action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case actionTypes.SEARCH_VALUE_SET:
      return state.merge({
        searchValue: payload.searchValue
      });

    case actionTypes.SEARCH_VALUE_CLEAR:
      return state.merge({
        searchValue: '',
        suggestions: Immutable.List(),
        results: Immutable.List(),
        highlightIndex: -1,
        focusSuggestions: false
      });

    case actionTypes.SUGGESTIONS_SET:
      return state.acceptSuggestions && state.searchValue === payload.searchValue ? state.merge({
        suggestions: Immutable.List(payload.suggestions)
      }) : state;

    case actionTypes.SUGGESTIONS_ACCEPT_SET:
      return state.merge({
        acceptSuggestions: payload.acceptSuggestions
      });

    case actionTypes.SUGGESTIONS_FOCUS_SET:
      return state.merge({
        focusSuggestions: payload.focusSuggestions,
        highlightIndex: 0
      });

    case actionTypes.SUGGESTIONS_CLEAR:
      return state.merge({
        suggestions: Immutable.List(),
        highlightIndex: -1
      });

    case actionTypes.HIGHLIGHT_INDEX_SET:
      return state.merge({
        highlightIndex: payload.index
      });

    case actionTypes.RESULTS_SET:
      {
        var results = Immutable.List((payload.results || []).map(function (result) {
          return new ResultRecord(result);
        }));
        return state.merge({
          results: results,
          ctaUrl: payload.ctaUrl,
          spelling: payload.spelling,
          noResultsFound: results.size === 0
        });
      }

    case actionTypes.NO_RESULTS_FOUND_SET:
      return state.merge({
        noResultsFound: payload.noResultsFound
      });

    case actionTypes.SEARCH_MODE_SET:
      return state.merge({
        searchMode: payload.searchMode
      });

    case actionTypes.LAST_SEARCHED_VALUE_SET:
      {
        return state.merge({
          lastSearchedValue: payload.lastSearchedValue
        });
      }

    default:
      throw new Error("Unhandled form action: ".concat(type));
  }
};

export default searchReducer;